/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2019, 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'react',
	'prop-types',
	'ca-ui-toolkit',
	'../../../widgets/livewidget/nls/StringResources',
	'../../../lib/@waca/dashboard-common/dist/lib/@ba-ui-toolkit/ba-graphics/dist/illustrations-js/nothing-here_128'
], function(
	React,
	PropTypes,
	UI_Toolkit,
	StringResources,
	emptyCustomStateIcon
) {

	const { Component } = React;
	const { FlexLayout, FlexItem, VSpacer, SVGIcon, Label, Button } = UI_Toolkit;

	class NoCustomVisuals extends Component {
		render () {
			const { customVisAction } = this.props;
			const openSelectBundleFileDialog = customVisAction.openSelectBundleFileDialog.bind(customVisAction);
			let msg;
			let buttonLabel;

			if (customVisAction.canManage()) {
				msg = StringResources.get('extVisNoCustomVisualsAdminMsg');
				buttonLabel = StringResources.get('extVisAddCustomVisual');
			} else {
				msg = StringResources.get('extVisNoCustomVisualsMsg');
			}

			return (
				<FlexLayout
					fullHeight
					direction="column"
					justifyContent='space-between'
					alignItems='center'
				>
					<FlexItem>
						<VSpacer size={3} />
					</FlexItem>
					<FlexItem>
						<FlexLayout
							fullHeight
							direction="column"
							justifyContent='center'
							alignItems='center'
							className='vis-no-custom-visuals'
						>
							<FlexLayout
								fullHeight
								direction="column"
								justifyContent='center'
								alignItems='center'
							>
								<FlexItem>
									<SVGIcon
										size='xxlarge'
										className='svgIcon'
										iconId={emptyCustomStateIcon.default.id} />
								</FlexItem>
								<FlexItem>
									<VSpacer size={3} />
								</FlexItem>
								<FlexItem>
									<Label
										className={'vis-no-custom-visuals-label'}
										label={StringResources.get('extVisNoCustomVisuals')}
									/>
								</FlexItem>
								<FlexItem>
									<VSpacer size={2} />
								</FlexItem>
								<FlexItem>
									<Label
										className={'vis-no-custom-visuals-msg'}
										label={msg}
									/>
								</FlexItem>
								{customVisAction.canManage() && (
									<div>
										<FlexItem>
											<VSpacer size={4} />
										</FlexItem>
										<FlexItem>
											<Button
												set={'primary'}
												label={buttonLabel}
												title={buttonLabel}
												onClick={() => openSelectBundleFileDialog()}
											/>
										</FlexItem>
									</div>
								)}
							</FlexLayout>
						</FlexLayout>
					</FlexItem>
					<FlexItem>
						<VSpacer size={3} />
					</FlexItem>
				</FlexLayout>
			);
		}
	}

	NoCustomVisuals.propTypes = {
		handlers: PropTypes.shape({
			openSelectBundleFileDialog: PropTypes.func.isRequired
		}).isRequired,
		customVisAction: PropTypes.object.isRequired
	};

	return NoCustomVisuals;
});
